import ExerciseGenerator from "./ExerciseGenerator";
import {getRandomIntegerWithinBitCount/*, getRandomIntegerWithRange*/} from "../Random";
import Exercise from "../Exercise";
import ResultItem from "../ResultItem";

export default class ConversionExerciseGenerator extends ExerciseGenerator{
    generate = (task) => {
        if(!task){
            task = getRandomIntegerWithinBitCount(this.getRandomBitCount());
        }
        const convertedTask = this.convertByNumberSystem(task, this.mode.getNumberSystems()[0]);

        const result = [];
        for(let i = 1; i<this.mode.getNumberSystems().length; i++){
            const numberSystem = this.mode.getNumberSystems()[i];
            result.push(
                new ResultItem(
                    this.convertByNumberSystem(task, numberSystem),
                    numberSystem,
                    true,
                    true
                )
            );
        }

        return new Exercise([task], [convertedTask], result);
    }

}